import type { IAccessLevelRepository } from '@yawi/domain';
import type { AccessLevel, AccessLevelSuccessResponse } from '@yawi/types';
import { getApiClient } from '../../http/apiClient';

const BASE = 'v1/tenant/integrations';

export class ApiAccessLevelRepository implements IAccessLevelRepository {
  async list(tenantId?: string): Promise<AccessLevel[]> {
    const qs = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
    return getApiClient().get<AccessLevel[]>(`${BASE}/access-levels${qs}`);
  }

  async setDefault(
    integrationId: string,
    accessLevelId: string,
    tenantId?: string,
  ): Promise<AccessLevelSuccessResponse> {
    const body: Record<string, string> = { accessLevelId };
    if (tenantId) body.tenantId = tenantId;
    return getApiClient().patch<AccessLevelSuccessResponse>(
      `${BASE}/${integrationId}/default-access-level`,
      body,
    );
  }

  async refresh(tenantId?: string): Promise<AccessLevelSuccessResponse> {
    const body = tenantId ? { tenantId } : undefined;
    return getApiClient().post<AccessLevelSuccessResponse>(
      `${BASE}/access-levels/refresh`,
      body,
    );
  }
}
